import { Spin as SpinAnt } from "antd";

import { LoadingOutlined } from "@ant-design/icons";
import { SpinSize } from "antd/es/spin";

export const Spin = ({
  centered,
  fullscreen,
  size,
}: {
  centered?: boolean;
  fullscreen?: boolean;
  size?: SpinSize;
}) => (
  <SpinAnt
    fullscreen={fullscreen}
    size={size}
    style={
      centered
        ? {
          position: "absolute",
          top: "calc(50% - 10px)",
          left: "calc(50% - 10px)",
          margin: "auto",
        }
        : undefined
    }
    indicator={<LoadingOutlined spin style={{ color: "grey" }} />}
  />
);
